
export const REQUEST_ENDINTERVIEW= 'REQUEST_ENDINTERVIEW';
export const ENDINTERVIEW_RECEIVED = 'ENDINTERVIEW_RECEIVED';
